import { getItem } from "src/services/sessionStorage";
import { isOnGenericUrl } from "src/util/url";

export const HOME_REALM_SESSION_KEY = "connections";

/** Config from KVS is usable when it names a connection or regional Auth0 tenant. */
export const hasUsableHomeRealmConfig = (config) =>
  Boolean(config && (config.auth0Connection || config.auth0TenantRegion));

export const readCachedHomeRealmConfig = () => {
  const cached = getItem(HOME_REALM_SESSION_KEY);
  return hasUsableHomeRealmConfig(cached) ? cached : null;
};

export const shouldFetchHomeRealmDiscovery = () =>
  !isOnGenericUrl() && !readCachedHomeRealmConfig();
